import './scroll_to_top.less';

import React, { Component } from 'react';
import classnames from 'classnames';
import autobind from 'class-autobind';

import { ArrowCircleUpIcon } from 'zoomforth_component_lib/external_modern_icons.jsx';

import {
  APP_CONTAINER_SELECTOR
} from 'zoomforth_codesbane_viewer/const/dom_selectors.js';

const SCROLL_DOWN_THRESHOLD_MAGNITUDE = 2;
const SCROLL_TRIGGER_THRESHOLD_PX = 200;

const SCROLL_DIRECTION_NONE = 'SCROLL_DIRECTION_NONE';
const SCROLL_DIRECTION_UP = 'SCROLL_DIRECTION_UP';
const SCROLL_DIRECTION_DOWN = 'SCROLL_DIRECTION_DOWN';

const PAGE_ELEMENT_POSITION_SELECTOR = '.outer-tiles-wrapper';

// Unfortunately this component is written in a non-reusable way. 
// If you want to use this in some component other than subpage_viewer.jsx be prepared to make some changes.
class ScrollToTop extends Component {
  constructor(props){
    super(props);

    this.state = {
      isHidden: true,
      windowHeight: 0,
      margin: 0
    };

    autobind(this);
  }
  componentDidMount(){
    this.element = window.jQuery(APP_CONTAINER_SELECTOR);
    
    this.element.on('scroll.scroll_to_top_component', this.scrollListener());
    window.jQuery(window).on('resize.scroll_to_top_component', this.resizeListener);
    this.resizeListener(); // place the button according to the current window size
  }

  componentWillUnmount(){
    this.element.off('scroll.scroll_to_top_component', this.scrollListener());
    window.jQuery(window).off('resize.scroll_to_top_component', this.resizeListener);
  }

  resizeListener(){
    const windowHeight = $(window).height();
    
    var margin = this.state.margin;
    if(!this.props.isMobile){
      margin = (window.jQuery(PAGE_ELEMENT_POSITION_SELECTOR).outerWidth(true) - window.jQuery(PAGE_ELEMENT_POSITION_SELECTOR).outerWidth() ) / 2;
    }

    this.setState({ margin, windowHeight });
    
  }

  scrollListener(){
    var lastScrollPosition = 0;
    var scrollUpCounter = 0;
    var scrollDownCounter = 0;

    return () => {
      const currentScrollPosition = this.element.scrollTop();

      if(currentScrollPosition == 0){
        this.setState({ isHidden: true });
        return;
      }
      
      const scrollDirection = currentScrollPosition > lastScrollPosition ?
        SCROLL_DIRECTION_DOWN
      : currentScrollPosition < lastScrollPosition ?
        SCROLL_DIRECTION_UP
      : 
        SCROLL_DIRECTION_NONE // this probably never happens
      ;

      const shouldShowButton = currentScrollPosition > (this.state.windowHeight * SCROLL_DOWN_THRESHOLD_MAGNITUDE);

      switch(scrollDirection){
      case SCROLL_DIRECTION_DOWN:
        scrollDownCounter += currentScrollPosition - lastScrollPosition;
        scrollUpCounter = 0;
        if(scrollDownCounter > SCROLL_TRIGGER_THRESHOLD_PX){
          this.setState({ isHidden: true });
        }
        break;
      case SCROLL_DIRECTION_UP:
        scrollUpCounter += lastScrollPosition - currentScrollPosition;
        scrollDownCounter = 0;
        if(shouldShowButton && scrollUpCounter > SCROLL_TRIGGER_THRESHOLD_PX){
          this.setState({ isHidden: false });
        }
      default:
          // do nothing
      }

      lastScrollPosition = currentScrollPosition;
    };
  }

  render(){
    const { isHidden, margin } = this.state;
    const { isMobile, onScrollToTop } = this.props;

    if(isHidden){
      return null;
    }

    return (
        <button
          style={{ right: margin }}
          className={classnames('scroll-to-top-container', isMobile ? 'mobile' : 'desktop')}
          onClick={() => onScrollToTop()} 
        >
          <div className="scroll-to-top">
            <span className="scroll-to-top-icon">
              <ArrowCircleUpIcon />
            </span>
            <span className="scroll-to-top-text">Back to top</span>
          </div>
        </button>
    );
  }
}

export default ScrollToTop;
